import { AuthorizeNetCreditCard } from './authorizenet-credit-card';

/** Payment profile. */
export class PaymentProfile {
  constructor(data) {
    this.customerPaymentProfileId = data.customerPaymentProfileId;

    /** @type {boolean} */
    this.isDefaultPaymentProfile = data.isDefaultPaymentProfile;
    this.billTo = {
      address: data.billTo.address,
      city: data.billTo.city,
      company: data.billTo.company,
      firstName: data.billTo.firstName,
      lastName: data.billTo.lastName,
      phoneNumber: data.billTo.phoneNumber,
      state: data.billTo.state,
      zip: data.billTo.zip,
    };
    this.payment = {

      /** @type {AuthorizeNetCreditCard} */
      creditCard: data.payment.creditCard,
    };
  }
}
